var map = {
	"./confetti.png": 2478,
	"./modal-bg.png": 2479,
	"./notice.jpg": 2480,
	"./premier-league-bg.png": 2481,
	"./reward-1.png": 2482,
	"./reward-2.png": 2483,
	"./reward-3.png": 2484,
	"./reward-4.png": 2485,
	"./reward-6.png": 2486,
	"./reward-9.png": 2487,
	"./versus.png": 2488,
	"./white-button-active.png": 2489,
	"./white-button-inactive.png": 2490,
	"./win-2.png": 2491,
	"./win.png": 2492,
	"./world-cup-vs-bg-mobile.jpg": 2493,
	"./world-cup-vs-bg.jpg": 2494,
	"./入场劵.jpg": 2495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 176;